<template>
    <b-modal
        v-model="modal"
        :id="'portfolio-edit-somtoday-share-link-modal'"
        :ref="'portfolio-edit-somtoday-share-link-modal'"
        :title="$t('portfolio.assignment_link')"
        :ok-title="$t('common.close')"
        ok-only
        ok-variant="primary"
        modal-class="apprentice-default-modal">
        <div class="somtoday-link">
            <p class="info">
                {{ $t('portfolio.use_this_link_for_sharing_the_assignment') }}
            </p>
            <div
                class="somtoday-url"
                id="somtoday-url">
                <b-alert
                    class="alert-copied"
                    :show="dismissTimer"
                    dismissible
                    variant="warning"
                    @dismissed="dismissTimer = 0"
                    @dismiss-count-down="dismissCountDownChanged">
                    {{ $t('portfolio.url_copied_to_clipboard') }}
                </b-alert>
                <b-form-input
                    class="hide-input"
                    readonly
                    aria-readonly="true"
                    :id="`somtoday-link`"
                    :value="url"
                    ref="somtoday-link"
                    type="text">
                </b-form-input>

                <div class="share">
                    <b-button
                        class="btn-url-copy"
                        variant="primary"
                        @click="copyToClipboard">
                        <i class="btn-duplicate"></i>{{ $t('portfolio.copy_link') }}
                    </b-button>

                    <b-button
                        class="st-share-button btn-share-somtoday"
                        variant="primary"
                        data-contenturl="http://example.org/yourpage">
                        <img
                            src="data:image/svg+xml;base64,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"
                            alt="Somtoday logo" />{{ $t('portfolio.share_SomToday') }}
                    </b-button>
                </div>
            </div>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-portfolio-edit-somtoday-share-link-modal-component',
    data() {
        return {
            url: '',
            modal: false,
            dismissSecs: 5,
            dismissTimer: 0,
        };
    },
    methods: {
        show(assignment_uuid, group_uuid) {
            this.url = this.routes.assignmentSomtodayShareUrl(assignment_uuid, group_uuid);
            this.modal = true;
            this.dismissTimer = 0;
        },

        copyToClipboard() {
            let url = document.getElementById('somtoday-link');
            url.select();
            const success = document.execCommand('copy');

            if (success) {
                this.dismissTimer = this.dismissSecs;
            }
            window.getSelection().removeAllRanges();
        },

        dismissCountDownChanged(dismissTimer) {
            this.dismissTimer = dismissTimer;
        },
    },
};
</script>

<style scoped lang="scss">
.alert-copied ::v-deep {
    margin-top: map-get($grid-gutter-spacing, 'twenty-one');

    .close {
        padding: map-get($grid-gutter-spacing, 'eight');
    }
}

.share {
    display: flex;
    flex-direction: column;

    .btn {
        justify-content: center;
        width: 100%;
        margin-bottom: map-get($grid-gutter-spacing, 'fifteen');
    }
}

.btn-url-copy,
.btn-share-somtoday {
    line-height: 1.2;
    font-size: $base-font-size;
}

.btn-url-copy {
    display: flex;
    flex-direction: row;
    align-items: center;
    align-self: center;

    i {
        margin-right: map-get($grid-gutter-spacing, 'eight');

        &:before {
            margin-right: 0;
        }
    }
}

.btn-share-somtoday {
    display: flex;
    align-items: center;
    height: 41px !important;
    background-image: unset !important;

    img {
        margin-right: map-get($grid-gutter-spacing, 'eight');
        width: 20px;
    }
}

@media (min-width: map-get($grid-breakpoints, 'sm')) {
    .share {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        .btn {
            justify-content: flex-start;
            max-width: calc(50% - 15px);
            width: auto;
        }
    }
}
</style>
